import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Project dashboard (PX-PRJ-010): features/dashboards.
export const Route = createFileRoute("/_app/project/dashboard")({
  component: () => <ModuleDashboard module="project" />,
});
